import { Icon } from '@chakra-ui/react';
import { IconButton } from '@/components/ui/icon-button';
import { FiX } from 'react-icons/fi';
import { Tooltip } from '@/components/ui/tooltip';
import { preventScrolling } from '@/utils/preventScrolling';
import { SLOT_CARD_ACTION_ICON_SIZE, SLOT_CARD_ICON_TARGET_SIZE } from './slotCardStyles';

/**
 * Dismisses an empty morphing slot card. Shared by the important-systems and
 * service category cards. The label is the slot's name (e.g. "Plumber"); it
 * drives both the tooltip and the accessible label as `Remove {label}`.
 */
interface SlotRemoveButtonProps {
	label: string;
	onRemove: () => void;
	testId?: string;
}

const SlotRemoveButton = (props: SlotRemoveButtonProps) => {
	const { label, onRemove, testId } = props;
	const action = `Remove ${label}`;

	return (
		<Tooltip content={action} openDelay={300} closeDelay={100}>
			<IconButton
				onMouseDown={preventScrolling}
				aria-label={action}
				size="sm"
				variant="ghost"
				minW={SLOT_CARD_ICON_TARGET_SIZE}
				w={SLOT_CARD_ICON_TARGET_SIZE}
				h={SLOT_CARD_ICON_TARGET_SIZE}
				p={0}
				color="fg.muted"
				data-testid={testId}
				onClick={(event) => {
					event.stopPropagation();
					onRemove();
				}}
			>
				<Icon as={FiX} boxSize={SLOT_CARD_ACTION_ICON_SIZE} />
			</IconButton>
		</Tooltip>
	);
};

export default SlotRemoveButton;
